import { User } from '@/shared/user';
import store from '@/store';
import { UserEmailChanged } from '@/shared/events/user-email-changed';

async function handleUserEmailChanged(data: UserEmailChanged): Promise<void> {
    const currentUser: User | null = store.getters['user/user'];

    if (currentUser == null || data.aggregateId !== currentUser.id) {
        return;
    }

    await store.dispatch('user/loadMeAsync', data);
}

export default handleUserEmailChanged;
